export interface ISystem {
  code: string;
  shop_token: string;
  session_token: string;
  request_token: string;
  customer_token: string;
  image_endpoint: string;
  topic_up: string;
  topic_down: string;
  topic_wc: string;
  is_close_a_y_c_confirm: boolean;
  datetime: string;
}

export class SystemDTO implements ISystem {
  code = "";
  shop_token = "";
  session_token = "";
  request_token = "";
  customer_token = "";
  image_endpoint = "";
  topic_up = "";
  topic_down = "";
  topic_wc = "";
  datetime = "";
  is_close_a_y_c_confirm = false;
}

export default class System extends SystemDTO {
  original = {};
  constructor(dto?: SystemDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      code : "",
      shop_token: "",
      session_token : "",
      image_endpoint : "",
      topic_up : "",
      topic_down : "",
      topic_wc : "",
      datetime : "",
      is_close_a_y_c_confirm : false,
    });
  }
}
